import { useQuery } from "@tanstack/react-query";
import APIClient from "../providers/apiClient";
import { genarateQueryString } from "../utils/";
import ms from "ms";

export const useWithdrawNethod = () => {
  const apiClient = new APIClient("/siteApi/withdrawMethods");
  return useQuery({
    queryKey: ["withdrawMethod"],
    queryFn: apiClient.getAll,
    staleTime: ms("24h"),
  });
};

export const useWithdrawBonus = () => {
  const apiClient = new APIClient("/cashier/withdrawDataProcess");
  return useQuery({
    queryKey: ["withdrawBonus"],
    queryFn: apiClient.getAll,
    staleTime: ms("24h"),
  });
};

export const useDepositBonus = () => {
  const apiClient = new APIClient("/cashier/depositData");
  return useQuery({
    queryKey: ["depositBonus"],
    queryFn: apiClient.getAll,
    staleTime: ms("24h"),
  });
};

export const useRolling = () => {
  const apiClient = new APIClient("/getRollingAmount")
  return useQuery({
    queryKey: ["rollingDetails"],
    queryFn: apiClient.getAll,
    // staleTime: ms("24h"),
  });
};

export const useBankAccounts = () => {
  const apiClient = new APIClient("/cashier/getBankAcc");
  return useQuery({
    queryKey: ["bankAccounts"],
    queryFn: apiClient.getAll,
    staleTime: ms("24h"),
  });
};

export const useTransactionMethods = () => {
  const apiClient = new APIClient("/cashier/getBankAcc");
  return useQuery({
    queryKey: ["transactionMethods"],
    queryFn: apiClient.getAll,
    staleTime: ms("24h"),
  });
};

export const useTransctionHistory = (params) => {
  let queryString = genarateQueryString(params);
  const apiClient = new APIClient(
    "/cashier/showAccountHistory_new?" + queryString
  );
  return useQuery({
    queryKey: ["transactionHistorys", params],
    queryFn: apiClient.getAll,
    staleTime: ms("1s"),
  });
};

export const useTransactionMethodsNew = () => {
  const apiClient = new APIClient("/cashier/s_transaction_method");
  return useQuery({
    queryKey: ["transactionMethodsNew"],
    queryFn: apiClient.getAll,
    staleTime: ms("24h"),
  });
};

export const useGameHistory = (game) => {
  const apiClient = new APIClient("/get_betting_history?table=" + game + "ALL");
  return useQuery({
    queryKey: ["gameHistory", game],
    queryFn: apiClient.getAll,
    // staleTime: ms("20s"),
  });
};

export const useBankPaymentSlips = () => {
  const apiClient = new APIClient("/cashier/bank_payment_bank_name")
  return useQuery({
    queryKey: ["bakPaymentSlips"],
    queryFn: apiClient.getAll,
    // staleTime: ms("24h"),
  });
};

export const useQRPayment = () => {
  const apiClient = new APIClient("/siteapi/getgeneralconfig/qrimg")
  return useQuery({
    queryKey: ["QR"],
    queryFn: apiClient.getAll,
    // staleTime: ms("24h"),
  });
};
export const usePointsDetails = () => {
  const apiClient = new APIClient("/point")
  return useQuery({
    queryKey: ["pointsDetails"],
    queryFn: apiClient.getAll,
    // staleTime: ms("24h"),
  });
};
export const useOtpBalance = () => {
  const apiClient = new APIClient("/cashier/getoptcash");
  return useQuery({
    queryKey: ["getoptcash"],
    queryFn: apiClient.getAll,
  });
};
export const useCurrencyRates = () => {
  const apiClient = new APIClient("/paymentgws/currency_rates");
  return useQuery({
    queryKey: ["depositBonus"],
    queryFn: apiClient.getAll,
  });
};
// export const useTransctionHistory = (params) => {
//   const apiClient = new APIClient("/cashier/showAccountHistory_new");
//   return useQuery({
//     queryKey: ["transactionHistorys", params],
//     queryFn: apiClient.getAll({
//       params,
//     }),
//   });
// };
